import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PhoneNumbers from './PhoneNumbers';
import { Container, Header, Tab } from './styles';
import HelpCenter from './HelpCenter';

const Support: FC = () => {
  return (
    <Container>
      <Header>
        <Tab label="Phone Numbers" to="/support/phone-numbers" />
        <Tab label="Help Center" to="/support/help-center" />
      </Header>
      <Switch>
        <Route component={PhoneNumbers} exact path="/support/phone-numbers" />
        <Route component={HelpCenter} exact path="/support/help-center" />

        <Redirect to="/support/phone-numbers" />
      </Switch>
    </Container>
  );
};

export default Support;
